import React, { useState } from 'react';
import WelcomeHeader from './components/WelcomeHeader';
import RegistrationForm from './components/RegistrationForm';
import TrustSignals from './components/TrustSignals';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const CustomerRegistration = () => {
  const [loading, setLoading] = useState(false);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  const handleRegistrationSubmit = async (formData) => {
    setLoading(true);
    try {
      // Handle registration logic here
      console.log('Registration data:', formData);
      // Add your API call or registration logic
    } catch (error) {
      console.error('Registration error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header Navigation */}
      <header className="bg-card border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button
              variant="ghost"
              onClick={handleBackToHome}
              iconName="ArrowLeft"
              iconPosition="left"
              className="text-muted-foreground hover:text-foreground"
            >
              Back to Home
            </Button>
            
            <div className="flex items-center space-x-2">
              <img
                src="/assets/images/No_Background-1763506485544.png"
                alt="HoliYay logo featuring a friendly fox mascot with Scottish heritage"
                className="h-8 w-auto"
              />
              <span className="font-semibold text-foreground">HoliYay</span>
            </div>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Welcome & Trust Signals */}
          <div className="space-y-8">
            <WelcomeHeader />
            
            <div className="hidden lg:block">
              <TrustSignals />
            </div>
          </div>

          {/* Right Column - Registration Form */}
          <div className="w-full max-w-md mx-auto lg:mx-0">
            <div className="bg-card rounded-2xl shadow-elevated p-8">
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  Create Your Account
                </h3>
                <p className="text-muted-foreground">
                  Join HoliYay and start planning your perfect holiday with expert guidance.
                </p>
              </div>

              <RegistrationForm 
                loading={loading}
                onSubmit={handleRegistrationSubmit}
              />
            </div>
          </div>
        </div>

        {/* Mobile Trust Signals */}
        <div className="lg:hidden mt-12">
          <TrustSignals />
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-card border-t border-border mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center space-y-4">
            <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
              <a href="/terms" className="hover:text-foreground transition-colors">Terms of Service</a>
              <a href="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</a>
              <a href="/support" className="hover:text-foreground transition-colors">Support</a>
            </div>
            
            <div className="flex items-center justify-center space-x-4">
              <Icon name="Shield" size={16} className="text-success" />
              <span className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} HoliYay. All rights reserved. Registered in England & Wales.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CustomerRegistration;